import { computedEager } from '@vueuse/core';
import { useToday } from './useToday';
import { useOptionToggle } from '@/composables/useOptionToggle';
import i18n from '@/i18n';

export interface UseTimePeriodToggleOptions {
	initialPeriod?: 'day' | 'week' | 'month' | 'year';
}

export const useTimePeriodToggle = (options: UseTimePeriodToggleOptions) => {
	const {
		selected,
		toggle,
		selectedLabel,
	} = useOptionToggle([
		{
			value: 'day',
			label: i18n.global.t('dashboard.loggedTimeStats.thisDay'),
		},
		{
			value: 'week',
			label: i18n.global.t('dashboard.loggedTimeStats.thisWeek'),
		},
		{
			value: 'month',
			label: i18n.global.t('dashboard.loggedTimeStats.thisMonth'),
		},
		{
			value: 'year',
			label: i18n.global.t('dashboard.loggedTimeStats.thisYear'),
		},
	], options.initialPeriod ?? 'month');

	const today = useToday();

	const selectedStartDate = computedEager(() => today.value.startOf(selected.value));

	return {
		selected,
		toggle,
		selectedLabel,
		selectedStartDate,
	};
};
